import Page from '../components/Page'
import Section from '../components/Section'
import PrimaryTitle from '../components/PrimaryTitle'

const pageTitle = 'neomento - Impressum'

const impressum = {
  title: 'Impressum',
  sections: [
    ['neomento GmbH', 'Ohmstraße 7', '10179 Berlin', 'GERMANY'],

    ['USTID: DE332737152'],
    ['Steuernummer: 30/453/50997'],

    ['Handelsregister: HRB 218751'],

    ['Registergericht: Amtsgericht Charlottenburg'],

    ['Vertretungsberechtigter Geschäftsführer:', 'Philipp Stepnicka'],
  ],
}

const contact = {
  title: 'Kontakt',
  sections: [['Telefon: +49 30 5490 7275-0', 'E-Mail: hello@neomento.de']],
}

export default function Impressum() {
  return (
    <Page title={pageTitle}>
      <Section>
        <PrimaryTitle title={impressum.title}></PrimaryTitle>
        <div className="space-y-6 mb-6">
          {impressum.sections.map((section, index) => (
            <div key={`impressum-section-1-${index}`}>
              {section.map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          ))}
        </div>
        <p className="font-bold">{contact.title}</p>
        <div className="space-y-6">
          {contact.sections.map((section, index) => (
            <div key={`impressum-section-2-${index}`}>
              {section.map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          ))}
        </div>
      </Section>
    </Page>
  )
}
